import React from 'react'

const OptionSelector = ({
  label,
  options,
  value,
  onChange,
  name,
  includeNone = true,
  noneLabel = 'None',
  required = false,
  isStringValue = false,
  radio = false,
  testId = null,
  optionTestIdPrefix = null
}) => {
  if (!options || options.length === 0) {
    return null
  }

  const handleChange = (stringValue) => {
    if (stringValue === '') {
      onChange(null)
    } else if (isStringValue) {
      onChange(stringValue)
    } else {
      onChange(parseInt(stringValue))
    }
  }

  const getOptionTestId = (option) => {
    if (!optionTestIdPrefix) return undefined
    const slug = option.name.toLowerCase().replace(/\s+/g, '-')
    return `${optionTestIdPrefix}-${slug}`
  }

  const RadioOptions = () => (
    <div className="flex flex-col gap-2">
      {includeNone && (
        <label className="flex items-center">
          <input
            type="radio"
            name={name}
            value=""
            checked={value === null || value === ''}
            onChange={(e) => handleChange(e.target.value)}
            required={required}
          />
          <span>{noneLabel}</span>
        </label>
      )}
      {options.map((option) => (
        <label key={option.id} className="flex items-center">
          <input
            type="radio"
            name={name}
            value={option.id}
            checked={String(value) === String(option.id)}
            onChange={(e) => handleChange(e.target.value)}
            required={required}
            data-testid={getOptionTestId(option)}
          />
          <span>{option.name}</span>
        </label>
      ))}
    </div>
  )

  const SelectOptions = () => (
    <select
      name={name}
      value={value || ''}
      onChange={(e) => handleChange(e.target.value)}
      required={required}
    >
      {includeNone && <option value="">{noneLabel}</option>}
      {options.map((option) => (
        <option key={option.id} value={option.id} data-testid={getOptionTestId(option)}>
          {option.name}
        </option>
      ))}
    </select>
  )

  return (
    <div data-testid={testId} className="w-full max-w-[50%]">
      {label && <label>{label}</label>}
      {radio ? <RadioOptions /> : <SelectOptions />}
    </div>
  )
}

export default OptionSelector
